'use strict';

const { pubdb } = Function('return this')();
const {
    $, window, make_datepicker, read_form_data, echo, ajax_post, ajax_success_next_handler,
    activate_tooltips, add_html_tooltip, next_tick,
} = pubdb;

$(function () {
// everything's in $(...) {{{



make_datepicker('#beginn, #ende');

var form = $('.form form');
var going_next = false;

var orig_data = read_form_data({form});

$(window).on('beforeunload', function () {
    if (going_next) {
        return;
    }

    var ex_unsaved = {};
    try {
        $(':input[name]:not(:radio)', form).each(function () {
            var self = $(this);
            if (self.is(':checkbox')) {
                var value = self.is(':checked');
            } else {
                var value = self.val();
            }
            if (orig_data[self.attr('name')] !== value) {
                throw ex_unsaved;
            }
        });
        $(':radio:checked', form).each(function () {
            var self = $(this);
            if (orig_data[self.attr('name')] !== self.val()) {
                throw ex_unsaved;
            }
        });
    } catch (e) {
        if (e === ex_unsaved) {
            return 'Es existieren ungesicherte Änderungen.';
        }
    }
});

function success (resp) {
    going_next = ajax_success_next_handler(resp, 'forschungsprojekt') === 'next';
}

function error (data, err, xhr) {
    echo('warn', 'Fehler (' + data.statusText + ') beim Speichern des Forschungsprojektes aufgetreten - bitte versuchen Sie es erneut');
}

function doSubmit () {
    var data = {};
    $(':input[name]:visible, input[type=hidden]', form).each(function () {
        var field = $(this);
        var name = field.attr('name');
        if (field.is(':checkbox')) {
            if (field.is(':checked')) {
                data[name] = true;
            } else {
                delete data[name];
            }
        } else if (field.is(':radio')) {
            if (field.is(':checked')) {
                data[name] = field.val();
            }
        } else {
            data[name] = field.val();
        }
    });
    ajax_post(form.attr('action'), data, success, error);
}

var do_preview = 0;

form.submit(function (ev) {
    if (do_preview) {
        --do_preview;
        form.attr('target', '_blank');
        form.find('[name=preview]').val('1');
    } else {
        ev.preventDefault();
        form.removeAttr('target');
        $(this).find('[name=preview]').val('');
        next_tick(doSubmit);
    }
});

$('#form_preview').click(function () {
    ++do_preview;
});

var option_keine_angabe = $('#typ_id [value="1"]').css('font-style', 'italic');
option_keine_angabe.parent().append(option_keine_angabe);

[
    ['wiss_einrichtung_id', true, 'Tragen Sie ein, in welcher Wissenschaftlichen Einrichtung das Projekt durchgeführt wurde.'],
    ['typ_id', true, 'Bitte wählen Sie die Projektart.'],
    ['titel_ger', true, 'Geben Sie den Titel in deutscher Sprache ein. Text in diesem Feld kann eingeschränkt HTML enthalten. Erlaubt sind <tt>&lt;i&gt;…&lt;/i&gt;</tt> (kursiv), <tt>&lt;sup&gt;…&lt;/sup&gt;</tt> (hochgestellt) und <tt>&lt;sub&gt;…&lt;/sub&gt;</tt> (tiefgestellt).'],
    ['titel_eng', false, 'Geben Sie den Titel in englischer Sprache ein. Text in diesem Feld kann eingeschränkt HTML enthalten. Erlaubt sind <tt>&lt;i&gt;…&lt;/i&gt;</tt> (kursiv), <tt>&lt;sup&gt;…&lt;/sup&gt;</tt> (hochgestellt) und <tt>&lt;sub&gt;…&lt;/sub&gt;</tt> (tiefgestellt).'],
    ['beginn', true, 'Bitte wählen Sie im Kalender ein Datum oder tragen es selbst in das Feld ein (Format: TT.MM.JJJJ)'],
    ['ende', true, 'Bitte wählen Sie im Kalender ein Datum oder tragen es selbst in das Feld ein (Format: TT.MM.JJJJ)'],
    ['ansprech_name', true, 'Bitte benennen Sie die Person, die in der Wissenschaftlichen Einrichtung Ansprechpartner für dieses Projekt ist.'],
    ['ansprech_link', true, 'Tragen Sie hier, wenn möglich, die Kontaktseite des Ansprechpartners ein! (Format: http://www. ...")'],
    ['abstract_ger', false, 'Falls eine Inhaltsangabe oder Zusammenfassung des Artikels/Beitrags verfasst wurde, können Sie sie hier einfügen. Text in diesem Feld kann eingeschränkt HTML enthalten. Erlaubt sind <tt>&lt;i&gt;…&lt;/i&gt;</tt> (kursiv), <tt>&lt;sup&gt;…&lt;/sup&gt;</tt> (hochgestellt) und <tt>&lt;sub&gt;…&lt;/sub&gt;</tt> (tiefgestellt).'],
    ['abstract_eng', false, 'Falls eine Inhaltsangabe oder Zusammenfassung des Artikels/Beitrags verfasst wurde, können Sie sie hier einfügen. Text in diesem Feld kann eingeschränkt HTML enthalten. Erlaubt sind <tt>&lt;i&gt;…&lt;/i&gt;</tt> (kursiv), <tt>&lt;sup&gt;…&lt;/sup&gt;</tt> (hochgestellt) und <tt>&lt;sub&gt;…&lt;/sub&gt;</tt> (tiefgestellt).'],
    ['mittelgeber', false, 'Falls das Forschungsprojekt extern finanziert wird, nennen Sie bitte den Förderer, z.B. DFG - Deutsche Forschungsgesellschaft.'],
    ['foerderkennzeichen', false, 'Falls vorhanden, bitte das Förderkennzeichen eintragen.'],
    ['titel_gesamt', false, 'Falls vorhanden, nennen Sie den übergeordneten Projekttitel.'],
    ['sprecher_gesamt', false, 'Falls vorhanden bzw. abweichend zur Kontaktperson nennen Sie hier bitte den Projektleiter.'],
    ['projekt_partner', false, 'Falls vorhanden, nennen Sie weitere Projektpartner, z.B. externe Institutionen oder Universitäten.'],
    ['international', false, ''],
    ['sonstiges', false, ''],
    ['veroeffentlichen', false, 'Wollen Sie das Projekt auf der Internetseite des Fachbereiches veröffentlichen? Dann klicken Sie ja. Wenn Sie "nein" wählen, können Sie das Projekt zu einem späteren Zeitpunkt noch veröffentlichen.']
].forEach(function ([name, required, message]) {
    const l = $(`label[for="${name}"]`);
    const container = $('#fp_content');

    if (required) {
        $('<div class="tooltip">Pflichtfeld</div>').prependTo(l);
        activate_tooltips($('<strong style="color:crimson; font-size:140%">*\xA0</strong>').prependTo(l), container);
    }

    if (message) {
        add_html_tooltip(l, message, container);
    }
});



// }}} everything's in $(...)
});
